/**
 * Vocabulaire selon le mode.
 * Troubadour : langue courante, terme technique entre parenthèses.
 * Maestro : vocabulaire de studio, sans périphrase.
 */
import type { Mode } from './types';

export function words(mode: Mode) {
  const t = mode === 'troubadour';
  return {
    quantizeAction: t ? 'Caler sur le tempo' : 'Quantifier',
    quantizeDesc: t ? 'Remet chaque note en place (quantifier)' : 'Aligne les transitoires sur la grille',
    denoiseAction: t ? 'Nettoyer le son' : 'Débruiter',
    denoiseDesc: t ? 'Enlève le souffle et la ronflette (débruitage)' : 'Filtres + soustraction spectrale',
    exportAction: t ? 'Exporter' : 'Exporter WAV',
    exportDesc: t ? 'Fichier WAV à glisser dans ton logiciel' : 'WAV 16-bit mono',
    onsets: t ? 'attaques (transitoires)' : 'onsets',
    onsetsDone: t ? 'notes calées' : 'onsets quantifiés',
    grid: t ? 'grille du tempo' : 'grid',
    loops: t ? 'Boucles' : 'Regions',
    loopsLower: t ? 'boucles' : 'regions',
    mix: t ? 'superposer' : 'mix',
    before: t ? 'Avant' : 'Original',
    after: t ? 'Après' : 'Quantifié',
    strength: t ? 'Intensité' : 'Force',
    softEnd: t ? 'Souple' : 'Doux',
    hardEnd: t ? 'Strict' : 'Fort',
    bpmUnit: t ? 'battements par minute' : 'BPM',
    tempo: t ? 'Tempo' : 'BPM',
    advanced: 'Réglages avancés — passer en Maestro',
    backSimple: 'Revenir en Troubadour',
    tip: 'Glisse sur la forme d’onde pour choisir un passage, puis crée une boucle.',
    tipPro: 'glisser = sélection · clic = position de lecture',
    tracks: t ? 'Pistes' : 'Tracks',
    addTake: t ? '＋ la prise' : '＋ prise',
    addLoop: t ? '＋ la boucle' : '＋ region',
    mixAll: t ? '▶ Tout jouer' : '▶ Mix',
    exportMix: t ? 'Exporter le mélange' : 'Exporter le mix',
    mute: t ? 'muet' : 'mute',
    tracksEmpty: t
      ? 'Aucune piste. Ajoute la prise en cours ou une boucle pour empiler tes couches, puis enregistre-en une autre par-dessus.'
      : 'Aucune track. Empile des prises ou des regions, puis joue-les ensemble.',
  };
}

export type Words = ReturnType<typeof words>;
